import { FC } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';

import { StyledButton } from './styled';

type PropsTypes = {
  handleResearch?: () => void;
  isListingPage?: boolean;
};

const SearchFlightButton: FC<PropsTypes> = ({
  handleResearch,
  isListingPage,
}) => {
  const { xl } = useBreakpoint();

  return (
    <StyledButton
      type={isListingPage && xl ? 'secondary' : 'primary'}
      onClick={handleResearch}
      data-testid='flight-search-button'
    >
      {isListingPage ? 'Yeniden' : 'Uçuş'} Ara
    </StyledButton>
  );
};

export default SearchFlightButton;
